import {
	IInputChangeEventArgs,
	IInputProps,
	BCInputSearch,
	BCInputSearchRef,
	IInputSearchProps
} from '@bimser/components';
import { FormItemTypes, IDictionary } from '@bimser/core';
import React, { JSX } from 'react';
import TextControl from '../../base/TextControl';
import { ISearchBoxProperties } from './entities/ISearchBoxProperties';
import { geti18nValue } from '../../../../helper';
import Styles from './assets/style.scss';
import { SizeType } from '../../../../entities/common';

export default class SearchBox extends TextControl {
	sizeType: SizeType;
	inputRef: BCInputSearchRef;
	constructor() {
		super();

		this.controlType = FormItemTypes.EControlTypes.SearchBox;

		this.subscribe('trigger:OnValueChanged', (value: string) => {
			this.triggerValueChanged({ data: value });
		});
	}

	__loadProperties(data: ISearchBoxProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.sizeType = data.sizeType;
	}

	protected triggerValueChanged(args: IInputChangeEventArgs) {
		this.__proxyChanging.value = args.data;
	}

	__getComponentData(): IInputSearchProps & IDictionary<any> {
		return {
			...super.__getComponentData(),
			sizeType: this.sizeType
		};
	}

	__getSizeType() {
		return this.sizeType ?? this.__form.sizeType;
	}

	focus(options?: { cursor?: 'start' | 'end' | 'all'; preventScroll?: boolean }) {
		this.inputRef?.inputRef?.focus(options);
	}

	__pureRender(ovverideInputProps?: IInputProps, controlProperties?: ISearchBoxProperties) {
		const properties: ISearchBoxProperties = controlProperties || (this as any);
		const inputSearchClasses = this.style.backgroundColor ? Styles.transparentContent : null;
		return (
			<BCInputSearch
				ref={ref => (this.inputRef = ref)}
				onChange={this.triggerValueChanged.bind(this)}
				className={inputSearchClasses}
				tabIndex={properties.tabIndex}
				placeHolder={geti18nValue(properties.placeholder, this.__form.currentLanguage)}
				maxLength={properties.maxLength}
				value={properties.value || properties.text}
				style={{ ...properties.style, ...{ '--bgcolor': this.style.backgroundColor } }}
				readOnly={this.__isReadOnly()}
				disabled={this.__isDisabled()}
				size={this.__getSizeType()}
				{...ovverideInputProps}
				textAlign={this.textAlign}
			/>
		);
	}

	__render(children?: JSX.Element) {
		return super.__render(this.__pureRender());
	}
}
